var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4849_15831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2498 5.06641H5.24984C5.09513 5.06641 4.94675 5.13313 4.83736 5.25191C4.72796 5.37068 4.6665 5.53177 4.6665 5.69974V13.2997C4.6665 13.4677 4.72796 13.6288 4.83736 13.7476C4.94675 13.8663 5.09513 13.9331 5.24984 13.9331H12.2498C12.4045 13.9331 12.5529 13.8663 12.6623 13.7476C12.7717 13.6288 12.8332 13.4677 12.8332 13.2997V5.69974C12.8332 5.53177 12.7717 5.37068 12.6623 5.25191C12.5529 5.13313 12.4045 5.06641 12.2498 5.06641ZM11.6665 12.6664H5.83317V6.33307H11.6665V12.6664Z",
    fill: "#00AFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49984 9.49896C3.49984 9.33099 3.43838 9.1699 3.32898 9.05112C3.21959 8.93235 3.07121 8.86562 2.9165 8.86562H2.33317V2.53229H8.1665V3.16562C8.1665 3.3336 8.22796 3.49469 8.33736 3.61346C8.44675 3.73223 8.59513 3.79896 8.74984 3.79896C8.90455 3.79896 9.05292 3.73223 9.16232 3.61346C9.27171 3.49469 9.33317 3.3336 9.33317 3.16562V1.89896C9.33317 1.73099 9.27171 1.5699 9.16232 1.45112C9.05292 1.33235 8.90455 1.26563 8.74984 1.26562H1.74984C1.59513 1.26563 1.44675 1.33235 1.33736 1.45112C1.22796 1.5699 1.1665 1.73099 1.1665 1.89896V9.49896C1.1665 9.66693 1.22796 9.82802 1.33736 9.94679C1.44675 10.0656 1.59513 10.1323 1.74984 10.1323H2.9165C3.07121 10.1323 3.21959 10.0656 3.32898 9.94679C3.43838 9.82802 3.49984 9.66693 3.49984 9.49896Z",
    fill: "#00AFBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4849_15831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.96eb43eb6e84c5f30f932f852702bfd3.svg";
export { ForwardRef as ReactComponent };